module.exports = __webpack_public_path__ + "img/Premium Clover 121.102244d2.jpg";